
    <ng-container *ngIf="isGroup; else defaultInput;">
      <div class="form-group">
        <div class="d-flex d-flex-gap">
          <fieldmagic-text
            purpose="input"
            [content]="label"
            [withRequiredMarker]="withRequiredMarker"
          >
          </fieldmagic-text>

        </div>
        <ng-container *ngTemplateOutlet="defaultInput"></ng-container>
      </div>
    </ng-container>

    <ng-template #defaultInput>
      <div class="input-icon">
        <input
          type="number"
          [attr.min]="min"
          [attr.max]="max"
          [attr.step]="step"
          class="{{ customClass }}"
          [placeholder]="placeholder"
          [disabled]="isDisabled$ | async"
          [(ngModel)]="value"
          (change)="onChange($event.target.value)"
          (focus)="onFocused()"
          (keypress)="onKeyPress($event)"
          [readonly]="isReadonly"
          [class.with-controls]="withControls"
        />
        <i>{{ strCurrencySymbol }}</i>
      </div>
    </ng-template>
  